import { Rectangle } from '@printu/geom';
import { getMarkerStyles } from 'app/core/markers/models';
import { strokeMarkerRenderer } from './painters';
const drawingStrategy = 'zoom-alone';
const renderEllipticalZoom = (zoom, viewToImageScale, buffer, ctx, area, opts) => {
    const it = ctx.getTransform();
    // this is used when exporting something in different size that the design size
    const globalScaleX = it.a;
    const globalScaleY = it.d;
    const imageToGlobalScaleX = globalScaleX / viewToImageScale;
    const imageToGlobalScaleY = globalScaleY / viewToImageScale;
    const widthHalf = zoom.width * 0.5;
    const heightHalf = zoom.height * 0.5;
    const radius = Math.min(widthHalf, heightHalf);
    let targetRadius = radius * 1.005;
    let zoomInSource = zoom.zoom;
    switch (drawingStrategy) {
        case 'zoom-alone':
            zoomInSource = targetRadius / zoom.zoom;
            break;
        case 'zoom-scaled':
            zoomInSource = targetRadius;
            targetRadius *= zoom.zoom;
            break;
        default:
            return;
    }
    const zoomSource = new Rectangle((zoom.x - area.x - zoomInSource) * imageToGlobalScaleX, (zoom.y - area.y - zoomInSource) * imageToGlobalScaleY, 2 * zoomInSource * imageToGlobalScaleX, 2 * zoomInSource * imageToGlobalScaleY);
    const zoomArea = {
        x: zoom.x + zoom.endX - targetRadius,
        y: zoom.y + zoom.endY - targetRadius,
        width: targetRadius * 2,
        height: targetRadius * 2,
    };
    const cx = zoomArea.x + targetRadius;
    const cy = zoomArea.y + targetRadius;
    // render stroke
    const style = getMarkerStyles(zoom);
    ctx.save();
    strokeMarkerRenderer(ctx, style, pCtx => {
        pCtx.beginPath();
        pCtx.moveTo(zoom.x, zoom.y);
        pCtx.lineTo(cx, cy);
        pCtx.closePath();
        pCtx.stroke();
        pCtx.beginPath();
        pCtx.ellipse(cx, cy, targetRadius, targetRadius, -Math.PI / 2, 0, 2 * Math.PI);
        pCtx.closePath();
    }, opts);
    ctx.restore();
    // render zoom
    const clipRadius = targetRadius;
    ctx.beginPath();
    ctx.ellipse(cx, cy, clipRadius, clipRadius, 0, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.clip();
    // grab any overlapping blurs -> apply blur before zooming
    ctx.drawImage(buffer, zoomSource.x, zoomSource.y, zoomSource.width, zoomSource.height, zoomArea.x, zoomArea.y, zoomArea.width, zoomArea.height);
};
const renderRectangularZoom = (zoom, viewToImageScale, buffer, ctx, area, opts) => {
    const it = ctx.getTransform();
    // this is used when exporting something in different size that the design size
    const globalScaleX = it.a;
    const globalScaleY = it.d;
    const imageToGlobalScaleX = globalScaleX / viewToImageScale;
    const imageToGlobalScaleY = globalScaleY / viewToImageScale;
    const { width, height } = zoom;
    let widthInSource = width * 0.5;
    let heightInSource = height * 0.5;
    switch (drawingStrategy) {
        case 'zoom-alone':
            widthInSource /= zoom.zoom;
            heightInSource /= zoom.zoom;
            break;
        case 'zoom-scaled':
            throw new Error('Not implemented');
            // zoomInImage = targetRadius;
            // targetRadius *= zoom.zoom;
            break;
        default:
            return;
    }
    const zoomSource = new Rectangle((zoom.x - area.x - widthInSource) * imageToGlobalScaleX, (zoom.y - area.y - heightInSource) * imageToGlobalScaleY, 2 * widthInSource * imageToGlobalScaleX, 2 * heightInSource * imageToGlobalScaleY);
    const zoomArea = {
        x: zoom.x + zoom.endX - width * 0.5,
        y: zoom.y + zoom.endY - height * 0.5,
        width,
        height,
    };
    const cx = zoomArea.x + width * 0.5;
    const cy = zoomArea.y + height * 0.5;
    // render stroke
    const style = getMarkerStyles(zoom);
    ctx.save();
    strokeMarkerRenderer(ctx, style, pCtx => {
        pCtx.beginPath();
        pCtx.moveTo(zoom.x, zoom.y);
        pCtx.lineTo(cx, cy);
        pCtx.closePath();
        pCtx.stroke();
        pCtx.beginPath();
        pCtx.rect(zoomArea.x, zoomArea.y, zoomArea.width, zoomArea.height);
        pCtx.closePath();
    }, opts);
    ctx.restore();
    // render zoom
    ctx.beginPath();
    ctx.rect(zoomArea.x, zoomArea.y, zoomArea.width, zoomArea.height);
    ctx.closePath();
    ctx.clip();
    // grab any overlapping blurs -> apply blur before zooming
    ctx.drawImage(buffer, zoomSource.x, zoomSource.y, zoomSource.width, zoomSource.height, zoomArea.x, zoomArea.y, zoomArea.width, zoomArea.height);
};
export const renderZoomMaker = (zoom, viewToImageScale, buffer, ctx, area, opts) => {
    ctx.save();
    switch (zoom.type) {
        case 'ellipse':
            renderEllipticalZoom(zoom, viewToImageScale, buffer, ctx, area, opts);
            break;
        case 'rect':
            renderRectangularZoom(zoom, viewToImageScale, buffer, ctx, area, opts);
            break;
        default:
            break;
    }
    ctx.restore();
};
